import React, { createContext, useContext } from 'react'

const CurrentQueryContext = createContext()

export const CurrentQueryProvider = ({ query, setQuery, clearQuery, children }) => (
  <CurrentQueryContext.Provider value={{ query, setQuery, clearQuery }}>
    {children}
  </CurrentQueryContext.Provider>
)

export const useCurrentQueryContext = () => useContext(CurrentQueryContext)
